import * as yup from 'yup';

import { l10n } from '@ott/l10n';
import cardValidator from '@ott/utility-card-validator';

import { ExcludeCountryRule } from '../../types';
import { validateByCountryCode } from './validateByCountryCode';

type Params = {
  excludeCardCountryCodes: ExcludeCountryRule[];
};

export const getCardNumberValidation = ({ excludeCardCountryCodes }: Params) => {
  let validator = yup
    .string()
    .required(l10n('required.required'))
    .test((cardNumber = '', { createError, path }) => {
      if (cardValidator.number(cardNumber).isValid) {
        return true;
      }

      return createError({
        message: l10n('wrong.cardNumber'),
        path,
      });
    });

  if (excludeCardCountryCodes.length) {
    validator = validator.test(async (value = '', { createError, path }) => {
      const message = await validateByCountryCode({ cardNumber: value, excludeCardCountryCodes });

      if (!message) {
        return true;
      }

      return createError({
        message,
        path,
      });
    });
  }

  return validator;
};
